var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25.4 17.7",
    style: {
      enableBackground: "new 0 0 25.4 17.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.2,17.7h-23c-0.7,0-1.2-0.5-1.2-1.2s0.5-1.2,1.2-1.2h23c0.7,0,1.2,0.5,1.2,1.2S24.9,17.7,24.2,17.7z M24.2,10.1h-23 C0.5,10.1,0,9.5,0,8.9s0.5-1.2,1.2-1.2h23c0.7,0,1.2,0.5,1.2,1.2S24.9,10.1,24.2,10.1z M24.2,2.4h-23C0.5,2.4,0,1.9,0,1.2 S0.5,0,1.2,0h23c0.7,0,1.2,0.5,1.2,1.2S24.9,2.4,24.2,2.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.df6c70d169617bbd502e45fddd42e14d.svg";
export { ForwardRef as ReactComponent };